import { EoReadOnly } from '../components/Fields';
import { SectionFrame } from '../components/SectionFrame';
import { formatDisplayDate } from '../format';
import type { SectionProps } from './sectionProps';

export function PayInformationSection({ setup, next, back }: SectionProps) {
  const p = setup.payInformation;
  return (
    <SectionFrame title="Pay Information" onSubmit={next} onBack={back}>
      <p className="eo-note">Your pay schedule is set by your employer. Contact your administrator if something looks wrong.</p>
      <div className="eo-grid">
        <EoReadOnly label="Pay Schedule" askKey="paySchedule" value={p.paySchedule} />
        <EoReadOnly label="Pay Period Start Date" askKey="payPeriodStartDate" value={p.periodStartDate ? formatDisplayDate(p.periodStartDate) : null} />
        <EoReadOnly label="Pay Day" askKey="payDay" value={p.payDay} />
        <EoReadOnly label="Hiring Date" askKey="hireDate" value={p.hireDate ? formatDisplayDate(p.hireDate) : null} />
      </div>
    </SectionFrame>
  );
}
